import { useState } from "react";
import { useHistory } from "react-router";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { PROPERTY_TYPE_VALUES } from "@/api/mappings/property";
import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { PropertyManagementDetailSnackbarState, useRequestInitialLoading } from "@/view_models/atoms";
import { SelectedProperty } from "@/view_models/propertySelectors";

export const useEditMonthlyCashflowResult = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const requestInitialLoading = useRequestInitialLoading();
  const selected_property = useRecoilValue(SelectedProperty);
  const setManagementDetailSnackBarState = useSetRecoilState(PropertyManagementDetailSnackbarState);

  // 元データを削除、新しいデータで作成することで編集を行う
  const editMonthlyCashflowResult = async (fieldsToDelete: string[], newData: any, originalMonth?: string) => {
    setLoading(true);
    const fp = PropallyApiFactory();

    try {
      // 元のフィールドを削除
      if (originalMonth) {
        const deleteData = { month: originalMonth };
        fieldsToDelete.forEach((field) => {
          deleteData[field] = null;
        });

        const deleteResult = await fp.v1PropertiesPropertyIdMonthlyCashflowResultsPatch(
          selected_property.id,
          deleteData,
          {
            withCredentials: true,
          }
        );

        if (deleteResult.status !== 200) {
          throw new Error("Failed to delete old data"); // 削除に失敗した場合はエラーを投げる
        }
      }

      // 新しいデータで作成
      const createResult = await fp.v1PropertiesPropertyIdMonthlyCashflowResultsPatch(selected_property.id, newData, {
        withCredentials: true,
      });

      if (createResult.status === 200) {
        requestInitialLoading();
      }
    } catch (e) {
      setManagementDetailSnackBarState({
        message: "物件情報を変更できませんでした",
        status: "error",
        isOpen: true,
      });
      if (selected_property.property.property_type === PROPERTY_TYPE_VALUES.consideration) {
        history.push("/management/consideration/detail");
      } else {
        history.push("/management/own/detail");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    editMonthlyCashflowResult,
    loading,
  };
};
